window.mrCopyHrefForAdmin = function( aTag ) {
	try {
		var url = new URL( aTag.getAttribute( 'href' ), window.location.href );
		navigator.clipboard.writeText( url.href.replace( url.protocol + '//', '' ).replace( url.host, '' ) );
	} catch {
		// Editor helper, don't care about errors
	}
};
